import { render, staticRenderFns } from "./importMaterials.vue?vue&type=template&id=7e85b3cc&scoped=true"
import script from "./importMaterials.vue?vue&type=script&lang=js"
export * from "./importMaterials.vue?vue&type=script&lang=js"
import style0 from "./importMaterials.vue?vue&type=style&index=0&id=7e85b3cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e85b3cc",
  null
  
)

export default component.exports